// Ported from vlookup-dramatic/app/contact-us/contact-form.tsx by scripts/revamp/port-design.js
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { contactPage } from "../../lib/content";
import { cn } from "../../lib/utils";
import * as homePageActions from "../../../actions/homePageActions";
import { showToasterWithOk } from "../../../utils/helpers";
const EMAIL_RE = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
function validate(name, email, message) {
    const errors = {};
    if (!name)
        errors.name = "Please enter your name";
    else if (name.length < 3)
        errors.name = "Your name should contain at least 3 characters";
    else if (name.length > 20)
        errors.name = "Your name should contain max 20 characters";
    if (!email)
        errors.email = "Please enter your email address";
    else if (!EMAIL_RE.test(email))
        errors.email = "Invalid email address";
    else if (email.length > 50)
        errors.email = "Your email should contain max 50 characters";
    if (!message)
        errors.message = "Please enter your message";
    else if (message.length < 5)
        errors.message = "Your message should contain at least 5 characters";
    return errors;
}
const fieldCls = "w-full rounded-[10px] border bg-card px-4 py-3 text-sm text-brand-navy outline-none placeholder:text-muted-foreground focus-visible:border-brand-red focus-visible:ring-2 focus-visible:ring-brand-red/20";
export function ContactForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [errors, setErrors] = useState({});
    const [sent, setSent] = useState(false);
    const [busy, setBusy] = useState(false);
    const dispatch = useDispatch();
    // POST contactUs via homePageActions.sendContactUs — same payload as the old
    // page ({ name, email, message }); the action shows the API's message as a toast.
    const onSubmit = async (e) => {
        e.preventDefault();
        const payload = { name: name.trim(), email: email.trim(), message: message.trim() };
        const next = validate(payload.name, payload.email, payload.message);
        setErrors(next);
        if (Object.keys(next).length > 0 || busy)
            return;
        setBusy(true);
        try {
            await dispatch(homePageActions.sendContactUs(payload));
            setSent(true);
            setName("");
            setEmail("");
            setMessage("");
        }
        catch (err) {
            showToasterWithOk((err && err.message) || "Something went wrong. Please try again.");
        }
        setBusy(false);
    };
    if (sent) {
        return (<p className="rounded-2xl bg-brand-red/8 px-5 py-6 text-sm leading-relaxed text-brand-navy">
        {contactPage.success}
      </p>);
    }
    return (<form onSubmit={onSubmit} noValidate className="mt-8 flex flex-col gap-4">
      <Field name="name" type="text" placeholder="Name*" value={name} error={errors.name} onChange={setName}/>
      <Field name="email" type="email" placeholder="Email Address*" value={email} error={errors.email} onChange={setEmail}/>
      <div>
        <textarea id="message" name="message" rows={6} placeholder="Message*" value={message} aria-invalid={Boolean(errors.message)} aria-describedby={errors.message ? "message-error" : undefined} onChange={(e) => setMessage(e.target.value)} className={cn(fieldCls, "min-h-[180px] resize-y", errors.message ? "border-brand-red" : "border-brand-navy/15")}/>
        {errors.message && (<p id="message-error" role="alert" className="mt-1.5 text-xs font-medium text-brand-red">
            {errors.message}
          </p>)}
      </div>
      <button type="submit" disabled={busy} className="mt-1 w-fit rounded-[10px] bg-brand-red px-10 py-2.5 text-base font-bold text-white transition-colors hover:bg-brand-red-dark disabled:opacity-60">
        {busy ? "Sending…" : contactPage.submit}
      </button>
    </form>);
}
function Field({ name, type, placeholder, value, error, onChange, }) {
    return (<div>
      <input id={name} name={name} type={type} placeholder={placeholder} value={value} aria-invalid={Boolean(error)} aria-describedby={error ? `${name}-error` : undefined} onChange={(e) => onChange(e.target.value)} className={cn(fieldCls, error ? "border-brand-red" : "border-brand-navy/15")}/>
      {error && (<p id={`${name}-error`} role="alert" className="mt-1.5 text-xs font-medium text-brand-red">
          {error}
        </p>)}
    </div>);
}
